import { StyleSheet } from 'aphrodite';
import { charmGray, white } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: 'auto',
		backgroundColor: white,
		paddingBottom: 30,
	},
	stickyHeader: {
		position: 'sticky' as const,
		top: 0,
		zIndex: 5,
		backgroundColor: white,
	},
	tabListWrapper: {
		flexShrink: 0,
		backgroundColor: white,
		marginBottom: 20,
	},
	integrationsSearchInput: {
		marginBottom: 20,
		maxWidth: 400,
		width: '100%',
	},
	placeholderContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		color: '#999',
		fontSize: 18,
	},
	content: {
		minWidth: 1118,
	},
	unauthorized: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		gap: 8,
	},
	contentCalendarButton: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		color: charmGray,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
		padding: '16px 16px 8px 16px',
		':hover': {
			backgroundColor: '#f7fafc',
		},
	},
});
